import { useNavigate } from 'react-router-dom';

const RED = '#b91d47', RED_D = '#8f1538', INK = '#1c1c28', GREY = '#7a7a8c', GREEN = '#22a06b';

export default function AppListSalon() {
  const navigate = useNavigate();

  const benefit = (i, t, d) => (
    <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start', marginBottom: 18 }}>
      <div style={{ width: 44, height: 44, borderRadius: 12, background: '#fdf2f5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, flexShrink: 0 }}>{i}</div>
      <div><div style={{ fontSize: 15, fontWeight: 700, color: INK }}>{t}</div><div style={{ fontSize: 13, color: GREY, marginTop: 2, lineHeight: 1.4 }}>{d}</div></div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#fff', maxWidth: 480, margin: '0 auto' }}>
      <div style={{ background: `linear-gradient(135deg,${RED},${RED_D})`, color: '#fff', padding: '20px 16px 30px' }}>
        <span onClick={() => navigate('/app/profile')} style={{ fontSize: 24, cursor: 'pointer' }}>‹</span>
        <div style={{ fontSize: 26, fontWeight: 800, marginTop: 16, letterSpacing: '-0.02em' }}>Apna Salon List Karein</div>
        <div style={{ fontSize: 14, opacity: 0.9, marginTop: 8, lineHeight: 1.5 }}>Hazaron customers tak pahunchein. Online bookings paayein. 3 mahine bilkul FREE.</div>
      </div>

      <div style={{ padding: 24 }}>
        {benefit('📈', 'Zyada Customers', 'Aapka salon aas-paas ke sabhi customers ko dikhega.')}
        {benefit('📅', 'Easy Bookings', 'Customer online book karega, aapko turant notification aayegi.')}
        {benefit('💰', '3 Mahine FREE', 'Pehle 3 mahine koi charge nahi. Baad me bhi sasta.')}
        {benefit('⭐', 'Reviews & Trust', 'Achhी reviews se zyada customers aayenge.')}

        <div style={{ background: '#fdf2f5', borderRadius: 14, padding: 16, marginTop: 8, marginBottom: 20 }}>
          <div style={{ fontSize: 13, color: INK, fontWeight: 700, marginBottom: 6 }}>ℹ️ Kaise kaam karta hai</div>
          <div style={{ fontSize: 12, color: GREY, lineHeight: 1.6 }}>
            1. Neeche form bharें (salon ka naam, photo, services)<br />
            2. Hamari team 24 ghante me verify karegi<br />
            3. Approve hote hi aapka dashboard khul jayega aur customer aapko dekhne lagenge
          </div>
        </div>

        <button onClick={() => navigate('/salon/register')} style={{ background: `linear-gradient(135deg,${RED},${RED_D})`, color: '#fff', border: 'none', borderRadius: 14, padding: 16, fontSize: 16, fontWeight: 700, width: '100%', cursor: 'pointer', boxShadow: '0 8px 20px rgba(185,29,71,.3)' }}>
          Start Registration →
        </button>
      </div>
    </div>
  );
}
